import { LogLevel, Configuration, PopupRequest } from "@azure/msal-browser";

const CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || "";
const TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID || "";
const REDIRECT_URI = process.env.REACT_APP_MSAL_REDIRECT_URI || "";
const POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "";
const AUTHORITY = process.env.REACT_APP_MSAL_AUTHORITY || "";

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `${AUTHORITY}/${TENANT_ID}`,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        // if (level === LogLevel.Error) console.error(message);
        // if (level === LogLevel.Info) console.info(message);
        // if (level === LogLevel.Verbose) console.debug(message);
        // if (level === LogLevel.Warning) console.warn(message);
      }
    }
  }
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read"]
};

